import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import NotFoundImg from '../Images/notfound.gif';

const NotFound = () => {
    return (
        <div>
            <div className='flex items-center justify-center h-screen mx-auto'>
                <img src={NotFoundImg} className="lg:w-6/12 md:w-7/12 w-8/12 mx-auto" alt="Not Found" />
            </div>
            <Link className='flex justify-center mb-10' to='/'><button className='btn border-0 text-white bg-green-500'> <FontAwesomeIcon className='mr-2' icon={faArrowLeft} /> Back Home</button></Link>
        </div>
    );
};

export default NotFound;